export interface BusinessHours {
    [key: string]: { openTime: string; closeTime: string };
};

export const defaultHours: BusinessHours = {
    Monday: { openTime: "08:00", closeTime: "18:00" },
    Tuesday: { openTime: "08:00", closeTime: "18:00" },
    Wednesday: { openTime: "08:00", closeTime: "18:00" },
    Thursday: { openTime: "08:00", closeTime: "18:00" },
    Friday: { openTime: "08:00", closeTime: "18:00" },
    Saturday: { openTime: "09:00", closeTime: "15:00" },
    Sunday: { openTime: "", closeTime: "" }, // Closed by default
};

export interface HeaderStyles {
    startColour: string;
    endColour: string;
    linkColour: string;
    linkHoverColour: string;
};

export interface ButtonStyles {
    backgroundColour: string;
    hoverColour: string;
    borderColour: string;
    textColour: string;
}

export interface ColourSettings {
    Header: HeaderStyles;
    PrimaryButton: ButtonStyles;
    SecondaryButton: ButtonStyles;
}

export const defaultColours = {
    Header: { startColour: "#F8F9FA", endColour: "#F8F9FA", linkColour: "#000000", linkHoverColour: "#555555" },
    PrimaryButton: { backgroundColour: "#555555", hoverColour: "#333333", borderColour: "#555555", textColour: "#ffffff" },
    SecondaryButton: { backgroundColour: "#ffffff", hoverColour: "#dddddd", borderColour: "#555555", textColour: "#000000" }
};

export interface SiteSettings {
    vatPercentage: number;
    currency: string;
    siteTitle: string;
    siteLogo: string,
    colourSettings: ColourSettings;  
    siteLabelLogo: string,
    siteLoadingIcon: string,
    siteFavicon: string,
    siteCSS: string
    hasPrice: boolean;
    allowDelivery: boolean;
    deliveryCost: number;
    allowEmailLogin: boolean;
    allowGoogleLogin: boolean;
    allowMicrosoftLogin: boolean;
    receiveOrdersAlways: boolean;
    receiveOrdersLoggedIn: boolean;
    receiveOrdersDuringHours: boolean;
    businessHours: BusinessHours;
    storeOnline: boolean;
    orderPin: boolean;
    isDefault: boolean;
    checkoutPaymentOptions: string[];
    checkoutPaymentOptionsEnabled: string[];
}

export const siteSettingsDefault: SiteSettings = {
    vatPercentage: 15,
    currency: "ZAR",
    siteTitle: "",
    siteLogo: "",
    colourSettings: defaultColours,
    siteLabelLogo: "",
    siteLoadingIcon: "",
    siteFavicon: "",
    siteCSS: "",
    hasPrice: true,
    deliveryCost: 0,
    receiveOrdersAlways: true,
    receiveOrdersDuringHours: false,
    receiveOrdersLoggedIn: false,
    businessHours: defaultHours,
    storeOnline: false,
    orderPin: true,
    allowDelivery: true,
    allowEmailLogin: true,
    allowGoogleLogin: true,
    allowMicrosoftLogin: true,
    isDefault: true,
    checkoutPaymentOptions: [],
    checkoutPaymentOptionsEnabled: []
}

export interface AliasSettings {

}

